import { Tooltip } from 'components/Tooltip/Tooltip'
import { BrandKitAvatar, BrandKitAvatarVerificationFailure, BrandKitAvatarVerificationStatus } from 'types'
import Styles from './VerificationPill.module.scss'

const PILL_CONFIGS: Record<BrandKitAvatarVerificationStatus, { label: string; bg: string; color: string }> = {
  pending: { label: 'Verifying', bg: '#EAEDF1', color: '#344054' },
  verified: { label: 'Verified', bg: '#ECFDF3', color: 'rgba(7, 148, 42, 1)' },
  rejected: { label: 'Needs new photo', bg: '#FDECEC', color: 'var(--red-70)' },
}

export const VERIFICATION_FAILURE_COPY: Record<BrandKitAvatarVerificationFailure, string> = {
  not_real_person: "We couldn't detect a real person in this photo. Upload a clear photo of a real person.",
  celebrity: 'This photo appears to show a public figure. Please upload your own photo instead.',
  unsuitable_photo:
    'This photo may not work well for video generation. Upload a clear, well-lit photo of one person facing the camera.',
  verification_failed: 'Something went wrong while verifying this photo. Try uploading it again.',
}

export const verificationFailureCopy = (avatar: BrandKitAvatar) =>
  VERIFICATION_FAILURE_COPY[avatar.verification_failure ?? 'verification_failed']

export const VerificationPill = ({ avatar }: { avatar: BrandKitAvatar }) => {
  const config = PILL_CONFIGS[avatar.verification_status]

  const pill = (
    <div className={Styles.pill} style={{ backgroundColor: config.bg, color: config.color }}>
      {config.label}
    </div>
  )

  if (avatar.verification_status !== 'rejected') return pill

  return (
    <Tooltip label={verificationFailureCopy(avatar)} placement="top">
      <div>{pill}</div>
    </Tooltip>
  )
}
